<div class="page-body">

  <div class="row">
    <div class="col-xl-12 col-md-12">

      <button  type="button" class="btn btn-warning " (click)="voltar()">
          <i  class="feather icon-arrow-left mr-2 f-18"></i> Voltar </button>
      <br> <br> 
  </div>

    <!-- amount-card start -->
    <div class="col-md-6 col-xl-4">
      <div class="card bg-c-blue amount-card o-hidden">
        <div class="card-block">
          <!--<i class="icon-arrow-up"></i>-->
          <h4 class=" text-white">15</h4>
        </div>

        <p>Documentos conforme</p>
      </div>
    </div>
    <div class="col-md-6 col-xl-4">
      <div class="card bg-c-red amount-card o-hidden">
        <div class="card-block">
          <!--<i class="icon-arrow-down"></i>-->
          <h4 class=" text-white">2</h4>
        </div>
 
        <p>Desconforme</p>
      </div>
    </div>
    <div class="col-md-6 col-xl-4">
      <div class="card bg-c-yellow amount-card o-hidden">
        <div class="card-block">
          <!--<i class="icon-arrow-up"></i>-->
          <h4 class=" text-white">2</h4>
        </div>
   
        <p>Alerta</p>
      </div>
    </div>
   
    <!-- amount-card end -->


    <!--<div class="col-md-12 col-xl-7">
      <div class="card past-payment-card">
        <div class="card-header">
          <div class="card-header-left ">
            <h5>Documentos</h5>
          </div>
        </div>
        <div class="card-block">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
              <tr>
                <th>Team Member</th>
                <th>Nome</th>
                <th>Tipo</th>
                <th>Vencimento</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  <a href="javascript:"><img class="img-radius img-40" src="assets/images/avatar-3.jpg" alt="chat-user"></a>
                  <p class="d-inline-block m-l-10 f-w-600">Erwin Brown</p>
                </td>
                <td>
                  <p>6:23</p>
                </td>
                <td>
                  <p>$20.00/hr</p>
                </td>
                <td>
                  <p>23 oct, 2017</p>
                </td>
              </tr>
              <tr>
                <td>
                  <a href="javascript:"><img class="img-radius img-40" src="assets/images/avatar-2.jpg" alt="chat-user"></a>
                  <p class="d-inline-block m-l-10 f-w-600">Joseph Villa</p>
                </td>
                <td>
                  <p>10:56</p>
                </td>
                <td>
                  <p>$25.00/hr</p>
                </td>
                <td>
                  <p>25 oct, 2017</p>
                </td>
              </tr>
              <tr>
                <td>
                  <a href="javascript:"><img class="img-radius img-40" src="assets/images/avatar-4.jpg" alt="chat-user"></a>
                  <p class="d-inline-block m-l-10 f-w-600">Jekson Durk</p>
                </td>
                <td>
                  <p>5:56</p>
                </td>
                <td>
                  <p>$23.00/hr</p>
                </td>
                <td>
                  <p>01 nov, 2017</p>
                </td>
              </tr>
              <tr>
                <td>
                  <a href="javascript:"><img class="img-radius img-40" src="assets/images/avatar-1.jpg" alt="chat-user"></a>
                  <p class="d-inline-block m-l-10 f-w-600">Erwin Brown</p>
                </td>
                <td>
                  <p>6:23</p>
                </td>
                <td>
                  <p>$16.00/hr</p>
                </td>
                <td>
                  <p>05 nov, 2017</p>
                </td>
              </tr>
              <tr>
                <td>
                  <a href="javascript:"><img class="img-radius img-40" src="assets/images/avatar-4.jpg" alt="chat-user"></a>
                  <p class="d-inline-block m-l-10  f-w-600">Gregory Durk</p>
                </td>
                <td>
                  <p>15:23</p>
                </td>
                <td>
                  <p>$40.00/hr</p>
                </td>
                <td>
                  <p>15 nov, 2017</p>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-xl-5 ">
      <div class="card project-task">
        <div class="card-header">
          <div class="card-header-left ">
            <h5>Audience by country</h5>
          </div>
        </div>
        <div class="card-block p-b-10">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
              <tr>
                <th>country</th>
                <th>Statistic</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  <div class="task-contain">
                    <h6 class="bg-c-blue d-inline-block text-center">IN</h6>
                    <p class="d-inline-block m-l-20">India</p>
                  </div>
                </td>
                <td>
                  <p class="d-inline-block m-r-20">80%</p>
                  <div class="progress d-inline-block">
                    <div class="progress-bar bg-c-blue" role="progressbar" aria-valuemin="0" aria-valuemax="100" style="width:80%">
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="task-contain">
                    <h6 class="bg-c-pink d-inline-block text-center">NY</h6>
                    <p class="d-inline-block m-l-20">New York</p>
                  </div>
                </td>
                <td>
                  <p class="d-inline-block m-r-20">60%</p>
                  <div class="progress d-inline-block">
                    <div class="progress-bar bg-c-pink" role="progressbar" aria-valuemin="0" aria-valuemax="100" style="width:60%">
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="task-contain">
                    <h6 class="bg-c-yellow d-inline-block text-center">UK</h6>
                    <p class="d-inline-block m-l-20">England</p>
                  </div>
                </td>
                <td>
                  <p class="d-inline-block m-r-20">50%</p>
                  <div class="progress d-inline-block">
                    <div class="progress-bar bg-c-yellow" role="progressbar" aria-valuemin="0" aria-valuemax="100" style="width:50%">
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="task-contain">
                    <h6 class="bg-c-green d-inline-block text-center">BZ</h6>
                    <p class="d-inline-block m-l-20">Brazil</p>
                  </div>
                </td>
                <td>
                  <p class="d-inline-block m-r-20">20%</p>
                  <div class="progress d-inline-block">
                    <div class="progress-bar bg-c-green" role="progressbar" aria-valuemin="0" aria-valuemax="100" style="width:20%">
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="task-contain">
                    <h6 class="bg-c-blue d-inline-block text-center">SA</h6>
                    <p class="d-inline-block m-l-20">Africa</p>
                  </div>
                </td>
                <td>
                  <p class="d-inline-block m-r-20">50%</p>
                  <div class="progress d-inline-block">
                    <div class="progress-bar bg-c-blue" role="progressbar" aria-valuemin="0" aria-valuemax="100" style="width:50%">
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>-->


  </div>

</div>
